export const contact = {
  email: "sales@ayro.co.uk",
  workingHours: "8:30am - 5:00pm",
  website: "https://ayro.co.uk/"
};

export const navItems = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" }
];

export const services = [
  {
    title: "Consulting",
    summary:
      "Practical technology advice for teams that need clear options, sound decisions, and delivery momentum.",
    details:
      "We help clarify requirements, assess technical choices, shape roadmaps, and turn complex system conversations into actionable next steps."
  },
  {
    title: "Audits & Assessments",
    summary:
      "Independent reviews of platforms, codebases, architecture, delivery practices, and technical risk.",
    details:
      "Our assessments focus on what matters: maintainability, cost, security posture, operational resilience, and the work needed to improve."
  },
  {
    title: "Bespoke Software Solutions",
    summary:
      "Custom applications, integrations, and workflow tools designed around how your business actually works.",
    details:
      "From discovery to delivery, we build software that reduces manual effort, connects systems, and gives teams reliable operational capability."
  },
  {
    title: "Project Management",
    summary:
      "Technical project leadership for software and platform work that needs structure, visibility, and follow-through.",
    details:
      "We support planning, delivery governance, stakeholder alignment, supplier coordination, and recovery of projects that need sharper control."
  }
];

export const credibility = [
  {
    title: "Decision support",
    text: "Clear technical options, trade-offs, and recommendations so stakeholders can move without guesswork."
  },
  {
    title: "Delivery focus",
    text: "Planning and execution support that keeps technical work connected to business outcomes."
  },
  {
    title: "System thinking",
    text: "Architecture, integrations, process, people, and operations considered together rather than in isolation."
  },
  {
    title: "Practical engineering",
    text: "Solutions designed to be maintainable, understandable, and useful after the first release."
  }
];

export const processSteps = [
  {
    title: "Understand",
    text: "We start with the business context, current systems, constraints, and the outcome you need."
  },
  {
    title: "Assess",
    text: "We identify risks, gaps, dependencies, and the sensible options before recommending a path."
  },
  {
    title: "Deliver",
    text: "We support implementation with pragmatic engineering, delivery control, and clear communication."
  }
];
